export enum severity {
    success = 'success',
    info = 'info',
    warning = 'warning',
    error = 'error',
}